import deburr from 'lodash.deburr'

export const strippedString = (string: string) => {
  return deburr((string || '').toLowerCase())
}
